import { useEffect, useState, useContext } from "react";
import { API } from "../conf";
import { Context } from "../App";
import { Box, Typography, Backdrop, CircularProgress, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, IconButton, Dialog, Stack } from "@mui/material";
import { Close, Info } from "@mui/icons-material";
import moment from "moment";

export default function DepenseHistory(props) {
    const { updateConnect } = useContext(Context)
    const [logs, setLogs] = useState([])
    const [log, setLog] = useState()
    const [load, setLoad] = useState(true)
    const [open, setOpen] = useState(false)
    const [comptes, setComptes] = useState([])
    

    useEffect(()=>{
        fetch(API.concat(`/depenses/${props.depense.num}/history`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    const sorted = json.map(log => {
                        log.user = log.who.nom+' '+log.who.prenom1+(Boolean(log.who.prenom2)?' '+log.who.prenom2:'')
                        log.what = JSON.parse(log.what)
                        return log
                    })
                    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
                    setLogs(sorted)
                }
                setLoad(false)
            }
        })

        fetch(API.concat(`/comptes/by/${JSON.stringify({eglise: props.eglise.number, type: {$ne:'petite-caisse'}})}`), {
            method:'GET',
            headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async(response) => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const comptes = await response.json()
                    setComptes(comptes); 
                }
            }
        })

    }, [props, updateConnect])

    return(
        <Box style={{display:'flex', flexDirection:'column', margin:'10px'}} sx={{overflow:'auto'}} >
            <Typography sx={{textAlign:'center', marginY:'20px', fontSize:26}}>Historique</Typography>
            {logs && !load && <TableContainer sx={{maxHeight:'100%'}}>
                <Table
                aria-labelledby="tableTitle">
                    <TableHead>
                        <TableRow>
                            <TableCell align='center' sx={{fontWeight:'bold'}} > Date </TableCell>
                            <TableCell align='center' sx={{fontWeight:'bold'}} > Utilisateur </TableCell>
                            <TableCell align='center' sx={{fontWeight:'bold'}} > Action </TableCell>
                            <TableCell align='center' sx={{fontWeight:'bold'}} > N° Facture </TableCell>
                            <TableCell ></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {logs.map((row, index) =>
                        <TableRow key={index} >
                            <TableCell align='center' sx={{minWidth:'70px'}}> {new Date(row.when).toLocaleDateString('fr-FR', {weekday: 'short',year: 'numeric', month: 'short',day: 'numeric'})} </TableCell>
                            <TableCell sx={{minWidth:'120px'}} style={{textTransform:'capitalize'}} align="center">{row.who.nom+' '+row.who.prenom1+' '+row.who.prenom2}</TableCell>
                            <TableCell sx={{minWidth:'100px'}} align="center">{row.action}</TableCell>
                            <TableCell sx={{minWidth:'100px'}} align="center">{row.what.num_facture}</TableCell>
                            <TableCell><IconButton aria-label="détail" onClick={()=>{setLog(row); setOpen(true)}}><Info fontSize="small"/></IconButton></TableCell>
                        </TableRow>
                    )}
                    </TableBody>
                </Table>
            </TableContainer>}
            <Dialog open={open} onClose={()=>setOpen(false)} maxWidth='xs' fullWidth>
                <IconButton sx={{position:'absolute', top:'5px', right:'5px'}} onClick={()=>{setOpen(false); setLog()}}><Close/></IconButton>
                {log && <Box margin='20px 10px'>
                    <Typography>Date: { moment.utc(log.what.date).format('DD/MM/YYYY')}</Typography>
                    <Typography textTransform={'capitalize'}>Libellé: {log.what.libelle}</Typography>
                    <Typography>Compte débité: {comptes.find(cpt=>cpt.num===log.what.compte)?.num_compte} {comptes.find(cpt=>cpt._id===log.what.compte)?.libelle}</Typography>
                    <Typography>Montant de la dépense: {log.what.montant.toFixed(2)}€</Typography>
                    <Typography>Mode de paiement:</Typography>
                    {log.what.paymode?.especes>0 && <Typography>Espèces: {log.what.paymode?.especes.toFixed(2)}</Typography>}
                    {log.what.paymode?.cheques.filter(cheque => cheque.montant>0).length>0 && <Stack sx={{marginLeft: '30px'}}>
                        <Typography>Chèques:</Typography>
                        {log.what.paymode?.cheques.filter(cheque => cheque.montant>0).map((cheque, index)=>
                            <Typography key={index} sx={{marginLeft: '20px'}}>chèque {cheque.banque} n°{cheque.num_cheque !== '' ? cheque.num_cheque : '_______'} de {cheque.montant.toFixed(2)}€</Typography>)}
                    </Stack>}
                    {log.what.paymode?.virement?.montant>0 && <Typography sx={{marginLeft: '30px'}}>Virment du {log.what.paymode?.virement.date!== '' ? moment.utc(log.what.paymode?.virement.date).format('DD/MM/YYYY') : '_______'} référencé 
                    {log.what.paymode?.virement.ref !== '' ? ` ${log.what.paymode?.virement.ref}` : ' _______'} de {log.what.paymode?.virement.montant.toFixed(2)}€</Typography>}
                    <Typography sx={{marginTop:'10px'}}>Facture:</Typography> 
                        {log.what.facture.filter(file => file!=='').map((file, index)=>(
                            <Typography key={index} fontSize={14} sx={{marginLeft:'15px'}}>{file.slice(file.lastIndexOf(`\\`)+1)}</Typography>))}  
                </Box>}
            </Dialog>
            <Backdrop open={load}><CircularProgress color="inherit" /></Backdrop>
        </Box>
    )
}